import { onMounted } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export function useTabTrap(overlayRef, emit) {
    let first, last, close
    let focusableElements = []
    const tabTrap = function (e) {
        if (e.shiftKey && e.target === first) {
            e.preventDefault()
            close.focus()
        }
        if (!e.shiftKey && e.target === last) {
            e.preventDefault()
            close.focus()
        }
    }

    function setTabTargets() {
        if (!overlayRef.value) return
        const tabbableElements = [
            'a[href]:not([tabindex="-1"])',
            'map[name] area[href]:not([tabindex="-1"])',
            'input:not([disabled]):not([tabindex="-1"])',
            'select:not([disabled]):not([tabindex="-1"])',
            'textarea:not([disabled]):not([tabindex="-1"])',
            'button:not([disabled]):not([tabindex="-1"])',
            'iframe:not([tabindex="-1"])',
            'object:not([tabindex="-1"])',
            'embed:not([tabindex="-1"])',
            '[tabindex]:not([tabindex="-1"])',
            '[contentEditable=true]:not([tabindex="-1"])'
        ]
        focusableElements = overlayRef.value.querySelectorAll(tabbableElements)
        close = document.querySelector('.kb-page-overlay__close')
        if (focusableElements.length) {
            first = focusableElements[0]
            last = focusableElements[focusableElements.length - 1]
            focusableElements.forEach((element) => {
                element.removeAttribute('data-order')
            })
            first.dataset.order = 'first'
            if (first !== last) {
                last.dataset.order = 'last'
            }
            if (typeof emit === 'function') {
                emit('setTabTargets')
            }
        }
    }

    onMounted(() => {
        setTabTargets()
        onTransitionendCallback(
            {
                opening() {
                    if (first) {
                        first.focus()
                    }
                    else {
                        close.focus()
                    }
                }
            },
            { persistent: true }
        )
    })

    return {
        setTabTargets,
        tabTrap
    }
}
